<template>
  <div class="d-flex justify-content-end pt-2 pr-4">
    <v-btn class="mr-1" icon @click="openGalleryPhotos()">
      <v-icon color="#3F51B5">mdi-image-multiple</v-icon>
    </v-btn>
    <v-btn icon @click="$refs.inputUpload.click()">
      <v-icon color="#3F51B5">mdi-camera</v-icon>
    </v-btn>
    <input v-show="false"
      accept="image/jpeg, image/png, image/gif, video/mp4, video/webm, video/ogg, video/avi, video/mpeg, video/quicktime, video/x-ms-wmv, video/x-flv"
      ref="inputUpload" type="file" @change="saveImage" />
    <GalleryPhotosUploadDlg ref="galleryPhotosUploadDlgRef" @uploadGalleryPhoto="uploadGalleryPhoto" />
  </div>
</template>

<script>
import { fileSizeToMB, validFileSize10MB, validVideoSize200MB } from '@/utils/fileSizeToMB';
import { optimizePhotos, uploadImage } from '@/utils/upload-image';
import { v4 as uuidv4 } from 'uuid';
import { waitResizedImage } from '@/utils/wait-resized-image';
import * as firebase from 'firebase/app';
import GalleryPhotosUploadDlg from '@/views/staff/gallery/GalleryPhotosUploadDlg/GalleryPhotosUploadDlg.vue';

export default {
  name: "ChatMediaUploader",
  components: {
    GalleryPhotosUploadDlg
  },
  props: {
    filePath: String
  },
  data() {
    return {
      dialog: false,
      url: ""
    }
  },
  methods: {
    openGalleryPhotos() {
      this.$refs.galleryPhotosUploadDlgRef.open();
    },
    uploadGalleryPhoto(image) {
      this.$emit('onImageSelected', image);
    },
    async saveImage(e) {

      if (!e || !e.target.files.length || !e.target.files[0]) return;

      const fileInput = this.$refs.inputUpload;
      const path = `${this.filePath}/${uuidv4()}`
      const file = await optimizePhotos(e.target.files[0], '');
      const fileSizeInMegabytes = fileSizeToMB(file?.size);

      const allowedImageTypes = ['image/jpeg', 'image/png', 'image/gif'];
      const allowedVideoTypes = ['video/mp4', 'video/webm', 'video/ogg', 'video/avi', 'video/mpeg', 'video/quicktime', 'video/x-ms-wmv', 'video/x-flv'];

      const isImage = allowedImageTypes.includes(file.type);
      const isVideo = allowedVideoTypes.includes(file.type);

      if (isImage && !validFileSize10MB(fileSizeInMegabytes)) {
        fileInput.value = null;
        return;
      }

      if (isVideo && !validVideoSize200MB(fileSizeInMegabytes)) {
        fileInput.value = null;
        return;
      }

      if (!isImage && !isVideo) {
        fileInput.value = null;
        throw Error('File type is not valid')
      }

      uploadImage({
        path,
        file,
        onStart: () => {
          this.imgLoading = true;
          this.$emit('onFileStartUpload');
        },
        onComplete: async storage => {
          try {
            const uploadedUrl = await storage.snapshot.ref.getDownloadURL();

            if (isImage) {
              const resizedImageRef = await firebase.storage().ref().child(`${path}_200x200`);
              const resizedImageUrl = await waitResizedImage(10, resizedImageRef);
              const file = {
                type: 'image',
                url: uploadedUrl,
                thumbnailUrl: resizedImageUrl
              }
              this.$emit('onFileUploaded', file);
            }

            if (isVideo) {
              const file = {
                type: 'video',
                url: uploadedUrl,
              }
              this.$emit('onFileUploaded', file);
            }

          } catch (e) {
            console.error(e)
            this.$emit('onFileUploaded', null);
          }
          fileInput.value = null;
          this.imgLoading = false;
        }
      });
    }
  }
}
</script>